import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import PhysicianUtils from 'services/PhysicianUtils';
import RouteUtils from 'services/RouteUtils';
import Schedule from 'components/Schedule';
import { PhysicianImage } from 'components/Common/UserImage';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { PhysicianPhysicianTypeEnum } from 'generated/api';
import DragAndDropCalendar from '../DragAndDropCalendar';

const DEFAULT_OBJET = {};

const PhysicianCalendar = (props) => {
  const {
    physician = DEFAULT_OBJET,
    date,
    moveEvent,
    onEventClick,
    shift,
    showCancelled,
    showActualTime,
    onSelectSlot,
    disableDragNDrop,
    clinicId,
  } = props;

  const nav = useNavStack(Stacks.Master);

  let selectedDate = (date || moment()).unix();

  function goToPractitionerProfile(practitioner) {
    let route = RouteUtils.getRoute(RouteUtils.routes().practitioner, {
      ':practitionerId': practitioner.id,
      ':tab?': undefined,
    });
    nav.push(route);
  }

  const className = useMemo(() => {
    let className = undefined;
    if (
      [PhysicianPhysicianTypeEnum.Phlebotomist, PhysicianPhysicianTypeEnum.Nurse].includes(
        physician.physician_type,
      )
    )
      className = 'secondary';
    return className;
  }, [physician.physician_type]);

  return (
    <li
      className={getPhysicianCalendarClassName(shift, physician)}
      key={physician.id || 'unassigned'}
    >
      <PhysicianHeader physician={physician} goToPractitionerProfile={goToPractitionerProfile} />
      <div className="schedule-wrapper">
        <div className="hour-only">
          <DragAndDropCalendar className="local-hour-only" />
        </div>
        <Schedule
          physician={physician}
          showDay={selectedDate}
          showCalendar={false}
          showAgendaToolbar={false}
          moveEvent={moveEvent}
          onEventClick={onEventClick}
          dontLoadDayAppointments={true}
          dontLoadPatients={true}
          showCancelled={showCancelled}
          showActualTime={showActualTime}
          onSelectSlot={onSelectSlot}
          disableDragNDrop={disableDragNDrop}
          className={className}
          clinicId={clinicId}
        />
      </div>
    </li>
  );
};

PhysicianCalendar.propTypes = {
  physician: PropTypes.object,
  width: PropTypes.string,
  date: PropTypes.object,
  moveEvent: PropTypes.func,
  onEventClick: PropTypes.func,
  shift: PropTypes.object,
  showCancelled: PropTypes.bool,
  showActualTime: PropTypes.bool,
  onSelectSlot: PropTypes.func,
  disableDragNDrop: PropTypes.bool,
  clinicId: PropTypes.string,
};

function getPhysicianCalendarClassName(shift, physician = {}) {
  let className = 'schedule';
  if (shift === undefined && physician.id !== undefined) className += ' no-shift';
  if (!physician.id) className += ' empty';
  return className;
}

const PhysicianHeader = ({ physician, goToPractitionerProfile }) => (
  <div
    className="physician-info"
    onClick={physician ? () => goToPractitionerProfile(physician) : undefined}
  >
    <PhysicianImage user={physician} className="profile-photo" />
    <span>{PhysicianUtils.getName(physician) || 'Unassigned'}</span>
  </div>
);

export default PhysicianCalendar;
